import React                                      from 'react'
import { ButtonToolbar, Tooltip, OverlayTrigger } from 'react-bootstrap'

import { AdminTable, GlyphButton } from 'alto-react-components/lib/components'
import { Client                  } from 'alto-react-kredit/lib/models'

class ClientTable extends AdminTable
  model: Client

  defaultFilters:
    id: ''
    name: ''
    gastroType: ''

  additionalTableClasses: 'three-actions'

  translateStatus: (status) ->
    switch status
      when 'A' then 'aktivní'
      when 'N' then 'neaktivní'
      else status

  columns: ->
    statusOptions = { 'aktivní': 'A', 'neaktivní': 'N' }

    [{
      property: 'firstname'
      header:
        label: 'Jméno'
        formatters: [@orderableAndFilterable()]
      filter:
        matcher: 'icontains'
     }, {
      property: 'surname'
      header:
        label: 'Příjmení'
        formatters: [@orderableAndFilterable()]
      filter:
        matcher: 'icontains'
     }, {
      property: 'email'
      header:
        label: 'Email'
        formatters: [@orderableAndFilterable()]
      filter:
        matcher: 'icontains'
     }, {
      property: 'clientId'
      header:
        label: 'ID klienta'
        formatters: [@orderableAndFilterable()]
      filter:
        matcher: 'icontains'
     }, {
      property: 'cardId'
      header:
        label: 'ID karty'
        formatters: [@orderableAndFilterable()]
      filter:
        matcher: 'icontains'
     }, {
      property: 'chipId'
      header:
        label: 'ID čipové karty'
        formatters: [@orderableAndFilterable()]
      filter:
        matcher: 'icontains'
     }, {
      property: 'status'
      header:
        label: 'Status'
        formatters: [@orderableAndFilterable(type: 'select', options: statusOptions)]
      cell:
        formatters: [@translateStatus]
      filter:
        matcher: 'exact'
     }]

  actionsFor: (id) ->
    <ButtonToolbar className='pull-right'>
      {@editButton(id)}
      {@editUserButton(id)}
      {@deleteButton(id)}
    </ButtonToolbar>

  editUserButton: (id) ->
    tooltip = <Tooltip id='tooltip'>Editovat webový účet</Tooltip>

    <OverlayTrigger placement='top' overlay={tooltip}>
      <GlyphButton onClick={=> @props.onEditUser(id)}
       glyph='globe' bsStyle='warning' bsSize='xsmall' />
    </OverlayTrigger>

export default ClientTable
